/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './integration-endpoint.reducer';

export const IntegrationEndpointDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const integrationEndpointEntity = useAppSelector(state => state.integrationEndpoint.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="integrationEndpointDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.integrationEndpoint.detail.title">IntegrationEndpoint</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.description}</dd>
          <dt>
            <span id="uri">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.uri">Uri</Translate>
            </span>
            <UncontrolledTooltip target="uri">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.uri" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.uri}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationEndpoint.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpoint.authType">Auth Type</Translate>
          </dt>
          <dd>{integrationEndpointEntity.authType ? integrationEndpointEntity.authType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpoint.protocol">Protocol</Translate>
          </dt>
          <dd>{integrationEndpointEntity.protocol ? integrationEndpointEntity.protocol.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpoint.httpServiceType">Http Service Type</Translate>
          </dt>
          <dd>{integrationEndpointEntity.httpServiceType ? integrationEndpointEntity.httpServiceType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpoint.method">Method</Translate>
          </dt>
          <dd>{integrationEndpointEntity.method ? integrationEndpointEntity.method.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpoint.channel">Channel</Translate>
          </dt>
          <dd>{integrationEndpointEntity.channel ? integrationEndpointEntity.channel.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/integration-endpoint" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/integration-endpoint/${integrationEndpointEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntegrationEndpointDetail;
